<template>
  <div class="bodyHome">
    <canvas id="canv" style="width: 100%; height: 100%"></canvas>
    <div id="headContent"></div>
    <div class="content">
      <div class="front_form c-search" style="background: transparent">
        <div class="vflex_item" style="flex-wrap: nowrap">
          <input
            placeholder="reference to authenticate"
            name="ref"
            class="c-search__input"
          /><button class="homeBtn" type="submit">
            <svg
              t="1665450385473"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3491"
              width="32"
              height="32"
            >
              <path
                d="M945.7 875L695 624.3c102.6-137.2 92-332.8-32.6-457.4-136.7-136.6-359-136.6-495.6 0-136.6 136.7-136.6 359 0 495.6C235.1 730.9 324.9 765 414.6 765c73.9 0 147.6-23.6 209.6-69.9l250.7 250.7c19.6 19.6 51.3 19.6 70.8 0s19.5-51.3 0-70.8zM237.6 591.8c-97.6-97.6-97.6-256.4 0-354 48.8-48.8 112.9-73.2 177-73.2s128.2 24.4 177 73.2c97.6 97.6 97.6 256.4 0 354-97.6 97.5-256.4 97.6-354 0z"
                fill="#ffffff"
                p-id="3492"
              ></path>
            </svg>
          </button>
        </div>
        <ul class="ulImg social">
          <li>
            <p class="screen-reader-text">
              <img src="../assets/face.png" class="facebook" alt="" />
            </p>
          </li>
          <li>
            <p class="screen-reader-text">
              <img src="../assets/gr.png" alt="" class="twitter" />
            </p>
          </li>
          <li>
            <p class="screen-reader-text">
              <img src="../assets/in.png" alt="" class="linkedin" />
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="menu-bg2"></div>
    <div class="menu-burger2">
      <a
        ><span
          ><div id="select_language" style="width: 5rem; text-align: center">
            <div class="dd-select" style="width: 5rem">
              <div class="dd-select">
                <button><span id="changeFromEn">EN</span></button>
              </div>
            </div>
          </div></span
        ></a
      >
    </div>
    <div class="logoproof">
      <img src="../assets/home.png" alt="logo" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld1',
  data() {
    return {
      canvas: {},
      stars_count: 0,
      stars: [],
      context: '',
      interval: null,
    }
  },
  created() {},
  mounted() {
    this.init()
    this.makeStars()
    this.drawStars()
    this.interval = setInterval(() => {
      this.drawStars()
    }, 50) //定时刷新星星数据
    let that = this
    // window.onresize = function () {
    //   //窗口大小发生变化时重新随机生成星星数据
    //   that.init()
    //   that.makeStars()

    //   that.interval = setInterval(function () {
    //     that.drawStars()
    //   }, 5000)
    // }
  },
  methods: {
    init() {
      //初始化
      this.canvas = document.getElementById('canv')
      this.canvas.width = window.innerWidth
      this.canvas.height = window.innerHeight
      this.context = this.canvas.getContext('2d')
      this.stars = Array() //数组存放随机生成的星星数据（x,y,大小，颜色，速度）
      this.stars_count = 100 //星星数量
      clearInterval(this.interval)
    },
    makeStars() {
      //随机生成星星数据
      for (var i = 0; i < this.stars_count; i++) {
        let x = Math.random() * this.canvas.offsetWidth
        let y = Math.random() * this.canvas.offsetHeight
        let radius = 2
        let color =
          'rgba(' +
          Math.random() * 206 +
          ',' +
          Math.random() * 177 +
          ',' +
          Math.random() * 143 +
          ',0.5)'
        let speed = Math.random() * 2
        let arr = { x: x, y: y, radius: radius, color: color, speed: speed } //（x,y,大小，颜色，速度）
        this.stars.push(arr) //随机生成的星星数据存在这里
      }
    },
    drawStars() {
      //把星星画到画布上
      this.context.fillStyle = 'rgba(10, 11, 35, 0.74)'
      this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
      for (var i = 0; i < this.stars.length; i++) {
        // var x = this.stars[i]['x'] - this.stars[i]['speed']
        var y = this.stars[i]['y'] - this.stars[i]['speed']
        // if (x < -2 * this.stars[i]['radius']) x = this.canvas.width
        // this.stars[i]['x'] = x
        // var y = this.stars[i]['y']
        if (y < -2 * this.stars[i]['radius']) y = this.canvas.height
        this.stars[i]['y'] = y
        var x = this.stars[i]['x']
        var radius = this.stars[i]['radius']
        this.context.beginPath()
        this.context.arc(x, y, radius * 2, 0, 2 * Math.PI)
        this.context.fillStyle =
          'rgba(' +
          Math.random() * 206 +
          ',' +
          Math.random() * 177 +
          ',' +
          Math.random() * 143 +
          Math.random() * 0.9 +
          ')'

        this.context.fillStyle = '#ceb18f'
        this.context.fill()
      }
    },
  },
}
</script>

<style scoped>
.bodyHome {
  background-image: radial-gradient(circle, #0a0b23, rgba(10, 11, 35, 0.74));
  opacity: 0.89;
  height: 100%;
  position: relative;
}
.content {
  position: relative;
  height: 100%;
}
canvas {
  position: fixed; /*设置定位*/
  top: 0;
  left: 0;
  z-index: -1; /*使画布基于最低层*/
  background: rgba(10, 11, 35, 0.74); /*画布背景色*/
}
.logoproof {
  position: absolute;
  bottom: 4.561rem;
  left: 2.2rem;
}
.front_form {
  z-index: 1000000;
  position: absolute;
  top: 40%;
  left: 0;
  width: 100%;
}
.front_form.c-search .vflex_item,
.front_next {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border: 0.175em solid #cdaf8f;
  border-radius: 16rem;
  padding: 0 !important;
  background: #cdaf8f;
  font-size: 1.5em;
  margin: auto;
  width: 90%;
}
.vflex_item {
  flex: 0 0 auto;
  min-height: 4.79rem;
  width: 100%;
}
.front_form .c-search__input,
.next .c-search__input {
  font-size: 0.9em !important;
  border-radius: 16rem;
}
.c-search__input,
.controlkey {
  font-family: 'Consolas', 'Inconsolata', monospace !important;
  float: left;
  padding: 0.625rem !important;
  color: #222;
  max-height: 3.125rem;
}
.c-search__input {
  text-transform: uppercase;
  width: 20em !important;
  border: none;
  max-width: 92% !important;
  margin: 0 !important;
}
.front_form .c-search__input:focus {
  outline: none;
}
.homeBtn {
  background-color: transparent;
  border: none;
}
.homeBtn {
  background: #cdaf8f !important;
  border: 0.175rem solid #cdaf8f !important;
  border-radius: 16rem !important;
  height: 4rem;
  width: 4rem;
  color: #cdaf8f !important;
}
.css-vubbuv {
  user-select: none;
  width: 1.6em;
  height: 1.6em;
  display: inline-block;
  fill: currentcolor;
  flex-shrink: 0;
  transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-size: 1.6rem;
  position: relative;
  left: -5px;
  top: -2px;
}
.menu-bg2,
.menu-burger2 {
  position: fixed;
  width: 5rem;
  height: 5rem;
  left: 1.8rem !important;
  /* line-height: 5rem; */
  text-align: center;
  border-radius: 100%;
  /* left: 2.5rem; */
  top: 3.5rem;
  z-index: 600000;
}
.menu-bg2 {
  opacity: 0.9;
  background: #cdaf8f;
  pointer-events: none;
  transition: 0.3s;
  left: 4.2rem !important;
  top: 5rem !important;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  -webkit-transform-origin: center center;
  transform-origin: center center;
}
.dd-select,
.dd-select > button,
.dd-select button {
  cursor: pointer !important;
}

.dd-container,
.dd-select {
  position: relative;
}
.dd-select > button {
  border: none;
  background: transparent;
  width: 100%;
}
.dd-select > button > span {
  color: #fff;
  font-size: 2rem;
  position: relative;
  top: -3px;
  cursor: pointer !important;
}
.ulImg {
  padding-left: 0;
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.ulImg li {
  list-style: none;
  color: #fff;
  margin-left: 20px;
}
.ulImg li:first-child {
  margin-left: 0;
}
.ulImg li p {
  width: 5rem;
}
.facebook,
.linkedin,
.twitter {
  border-radius: 100%;
  background-color: #cdaf8f;
  opacity: 1;
  width: 100%;
  max-width: 5rem;
}
.icon {
  width: 100%;
  height: 100%;
}
</style>
